<template>
  <div v-if="selectedCount > 0" class="products-bulk-panel">
    <div class="products-bulk-panel__content">
      <span class="products-bulk-panel__count"> Выбрано: {{ selectedCount }} </span>
      <div class="products-bulk-panel__actions">
        <va-select
          :value="categoryToAdd"
          :options="bulkCategoryOptions"
          text-by="name"
          value-by="id"
          label="Категория"
          size="small"
          class="products-bulk-panel__category-select"
          :disabled="bulkActionLoading"
          @input="$emit('update:category-to-add', $event)"
        />
        <va-button
          size="small"
          color="primary"
          :disabled="bulkActionLoading || !selectedBulkCategoryId"
          @click="$emit('bulk-add-category')"
        >
          Добавить категорию
        </va-button>
        <va-button
          size="small"
          color="warning"
          :disabled="bulkActionLoading || !selectedBulkCategoryId"
          @click="$emit('bulk-remove-category')"
        >
          Убрать категорию
        </va-button>
        <va-button
          size="small"
          color="success"
          :disabled="bulkActionLoading"
          @click="$emit('bulk-set-available', true)"
        >
          В наличии
        </va-button>
        <va-button
          size="small"
          color="warning"
          :disabled="bulkActionLoading"
          @click="$emit('bulk-set-available', false)"
        >
          Нет в наличии
        </va-button>
        <va-button
          size="small"
          color="secondary"
          :disabled="bulkActionLoading"
          @click="$emit('bulk-set-hidden', true)"
        >
          Скрыть
        </va-button>
        <va-button
          size="small"
          color="info"
          :disabled="bulkActionLoading"
          @click="$emit('bulk-set-hidden', false)"
        >
          Показать
        </va-button>
        <va-button
          size="small"
          color="danger"
          :disabled="bulkActionLoading"
          @click="$emit('bulk-delete-selected')"
        >
          Удалить
        </va-button>
        <va-button
          flat
          size="small"
          color="gray"
          @click="$emit('clear-selection')"
        >
          Снять выделение
        </va-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductsBulkPanel",
  props: {
    selectedCount: {
      type: Number,
      required: true,
    },
    categoryToAdd: {
      type: [String, Number, Object],
      default: "",
    },
    bulkCategoryOptions: {
      type: Array,
      default: () => [],
    },
    selectedBulkCategoryId: {
      type: Number,
      default: null,
    },
    bulkActionLoading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss">
.products-bulk-panel {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  color: var(--va-on-secondary);
  padding: 12px 24px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.15);
  z-index: 100;
}

.products-bulk-panel__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  max-width: 1400px;
  margin: 0 auto;
}

.products-bulk-panel__count {
  font-weight: 600;
  font-size: 1rem;
}

.products-bulk-panel__actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.products-bulk-panel__category-select {
  min-width: 260px;
}
</style>
